export default __webpack_public_path__ + "static/media/noJobsFallbackIcon.25659d70.svg";